enum InvoiceModalType {
  SELECT_INVOICE = 'SELECT_INVOICE',
  FIXED_PRICE_INVOICE = 'FIXED_PRICE_INVOICE'
}

export default InvoiceModalType;
